<div class="container-fluid">
  <div class="process-list-toolbar d-flex justify-content-between align-items-center">
    <div class="process-task-button">
      <button mat-raised-button color="accent" (click)="refresh(true)">
        <fa-icon [icon]="faRecycle"></fa-icon>
        Refresh
      </button>
    </div>
    <div>
      <mat-form-field class="task-viewer-toolbar-element-margin" appearance="standard" *ngIf="viewMode === 'tile'">
        <mat-label>Search</mat-label>
        <input [(ngModel)]="searchString" name="searchString" type="text" matInput placeholder="Seach anything...">
        <span matSuffix>
          <fa-icon [icon]="faMagnifyingGlass"></fa-icon>
        </span>
      </mat-form-field>
      <!--<mat-radio-group [(ngModel)]="viewMode">
        <mat-radio-button class="task-viewer-toolbar-element-margin" value="tile">
          Tiles
        </mat-radio-button>
        <mat-radio-button class="task-viewer-toolbar-element-margin" value="grid">
          Grid
        </mat-radio-button>
      </mat-radio-group>-->
    </div>
  </div>
  <div class="row" *ngIf="viewMode === 'tile'">
    <div class="items-list row">
      <div class="single-item" *ngFor="let task of taskViewerModel.tasks | filterProjects:searchString; let i = index ">
        <app-task-viewer-tile *ngIf="task.progress !== -1" class="w-100" [task]="task" (cancelTaskEvent)="cancelTask($event, task)"></app-task-viewer-tile>
      </div>
    </div>
  </div>
  <!--<div class="row" *ngIf="viewMode === 'grid'">
    <dx-data-grid id="tasksGrid"
                  [dataSource]="taskViewerModel.tasks"
                  [remoteOperations]="true"
                  [allowColumnReordering]="true"
                  [rowAlternationEnabled]="true"
                  [showBorders]="true"
                  [columns]="taskGridColumns"
                  [columnAutoWidth]="true"
                  [showScrollbar]="true"
                  [width]="'100%'">
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
      <div *dxTemplate="let item of 'detail'">
        <dx-data-grid [dataSource]="item.taskBlocks"
                      [showBorders]="true"
                      [columnAutoWidth]="true">
          <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
        </dx-data-grid>
      </div>
    </dx-data-grid>
  </div>-->
</div>
